import Trail               from "../../fundamentals/trail/Trail";
import MailTemplateContent from "./MailTemplateContent";
import MailTemplateId      from "./MailTemplateId";
import MailTemplateName    from "./MailTemplateName";
import MailTemplateSubject from "./MailTemplateSubject";

class MailTemplate {
  constructor(
    private readonly _id: MailTemplateId = new MailTemplateId(),
    private readonly _name: MailTemplateName = new MailTemplateName(),
    private readonly _subject: MailTemplateSubject = new MailTemplateSubject(),
    private readonly _content: MailTemplateContent = new MailTemplateContent(),
    private readonly _trail: Trail = new Trail(),
  ) {
  }

  get id() {
    return this._id;
  }

  get name() {
    return this._name;
  }

  get subject() {
    return this._subject;
  }

  get content() {
    return this._content;
  }

  get trail() {
    return this._trail;
  }
}

export default MailTemplate;
